import { debounce, isFunction } from '@antv/util';
import { GraphEvent } from '../constants';
import { setVisibility } from '../utils/visibility';
import { BaseBehavior } from './base-behavior';
/**
 * <zh/> 操作画布过程中隐藏元素
 *
 * <en/> Hide elements during canvas operations (dragging, zooming, scrolling)
 */
export class OptimizeViewportTransform extends BaseBehavior {
    static defaultOptions = {
        enable: true,
        debounce: 200,
        shapes: { node: ['key'] },
    };
    isVisible = true;
    constructor(context, options) {
        super(context, Object.assign({}, OptimizeViewportTransform.defaultOptions, options));
        this.bindEvents();
    }
    filterShapes = (shapes, classnames) => {
        return shapes.filter((shape) => shape.className && !classnames?.includes(shape.className));
    };
    setElementsVisibility = (elements, visibility, excludedClassnames) => {
        elements.forEach((element) => {
            setVisibility(element, visibility, excludedClassnames && ((shapes) => this.filterShapes(shapes, excludedClassnames)));
        });
    };
    hideShapes = (event) => {
        if (!this.validate(event) || !this.isVisible)
            return;
        const { element } = this.context;
        const { shapes = {} } = this.options;
        this.setElementsVisibility(element.getNodes(), 'hidden', shapes.node);
        this.setElementsVisibility(element.getEdges(), 'hidden', shapes.edge);
        this.setElementsVisibility(element.getCombos(), 'hidden', shapes.combo);
        this.isVisible = false;
    };
    showShapes = debounce((event) => {
        if (!this.validate(event) || this.isVisible)
            return;
        const { element } = this.context;
        this.setElementsVisibility(element.getNodes(), 'visible');
        this.setElementsVisibility(element.getEdges(), 'visible');
        this.setElementsVisibility(element.getCombos(), 'visible');
        this.isVisible = true;
    }, this.options.debounce);
    bindEvents() {
        const { graph } = this.context;
        graph.on(GraphEvent.BEFORE_TRANSFORM, this.hideShapes);
        graph.on(GraphEvent.AFTER_TRANSFORM, this.showShapes);
    }
    unbindEvents() {
        const { graph } = this.context;
        graph.off(GraphEvent.BEFORE_TRANSFORM, this.hideShapes);
        graph.off(GraphEvent.AFTER_TRANSFORM, this.showShapes);
    }
    validate(event) {
        if (this.destroyed)
            return false;
        const { enable } = this.options;
        if (isFunction(enable))
            return enable(event);
        return !!enable;
    }
    destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
//# sourceMappingURL=optimize-viewport-transform.js.map